import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
  selector: "[preventHorizontalNav]",
  standalone: false,
})
export class PreventHorizontalNavDirective {
  constructor(private elementRef: ElementRef) {}

  @HostListener("wheel", ["$event"])
  onWheel(event: WheelEvent): void {
    // Check if there's horizontal scroll happening
    if (Math.abs(event.deltaX) > 0) {
      event.preventDefault();
      // Manually scroll the element
      this.elementRef.nativeElement.scrollLeft += event.deltaX;
    }
  }
}
